// extracted by mini-css-extract-plugin
export default {"create-new-cert-btn":"ActionsColumn_create-new-cert-btn__6ZPX+"};